<span><ng-template #helpContent>
        <span class="e2e-inner-html-bound" [innerHTML]="help"></span>
    </ng-template>
    <span *ngIf="help" class="edl-tooltip-icon ms-2" triggers="click" [autoClose]="'inside'" title="Help"
        placement="auto" container="body" [ngbTooltip]="helpContent">
        <i [ngClass]="icon"></i>
    </span>

    <ng-template #exampleContent>
        <span class="e2e-inner-html-bound" [innerHTML]="example"></span>
    </ng-template>
    <span *ngIf="example" class="edl-tooltip-icon ms-2" triggers="click" [autoClose]="'inside'"
        title="Click to show/hide example" [ngbTooltip]="exampleContent" placement="auto" container="body">
        <b>Ex</b></span>
</span>